export default __webpack_public_path__ + "static/media/galeria-drivr5.53dde524.JPG";